import * as React from 'react';

import styled from 'styled-components';

import Typography from '@components/basics/typography';
import MotionOpacity from '@components/motion/motion-opacity';
import Grid from '@components/basics/grid';

interface NotificationItemChangeProps {
  className?: string;
  title?: string;
  text: string;
}

export const NotificationItemChange: React.FC<NotificationItemChangeProps> = ({
  className,
  title,
  text,
}) => {
  return (
    <ItemWrapper className={className}>
      <ItemContent>
        <Grid gap={8}>
          {title && <Typography type="title">{title}</Typography>}
          {text && <Typography type="small">{text}</Typography>}
        </Grid>
      </ItemContent>
    </ItemWrapper>
  );
};

export default NotificationItemChange;

const ItemContent = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
`;

const ItemWrapper = styled(MotionOpacity)`
  margin-bottom: 16px;
  opacity: 1;

  @media ${({ theme }) => theme.device.laptop} {
    position: relative;
    margin-bottom: 24px;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;
